export const isNullish = (value: unknown): boolean => value === null || value === undefined;
